import { render, staticRenderFns } from "./select-people-yunqi.vue?vue&type=template&id=7ce22d21&scoped=true"
import script from "./select-people-yunqi.vue?vue&type=script&lang=js"
export * from "./select-people-yunqi.vue?vue&type=script&lang=js"
import style0 from "./select-people-yunqi.vue?vue&type=style&index=0&id=7ce22d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce22d21",
  null
  
)

export default component.exports